(() => {
  const popup = document.getElementById('dt-welcome');
  if (!popup || typeof popup.showModal !== 'function' || popup.dataset.bound) return;
  popup.dataset.bound = 'true';
  const key = 'dt-welcome-v1';
  const week = 7 * 24 * 60 * 60 * 1000;
  let previousFocus;
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = value => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const open = () => { if (!popup.isConnected || popup.open) return; previousFocus = document.activeElement; popup.showModal(); };
  const close = () => popup.close();
  popup.querySelector('.dt-welcome-close').addEventListener('click', close);
  popup.querySelector('.dt-welcome-skip').addEventListener('click', close);
  popup.addEventListener('click', event => { if (event.target === popup) { const r = popup.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  popup.addEventListener('close', () => { if (!popup.querySelector('[data-welcome-success]')) write({ dismissed: Date.now() }); previousFocus?.focus?.(); });
  if (popup.querySelector('[data-welcome-success]')) { write({ subscribed: true }); open(); popup.querySelector('[data-welcome-success]').focus(); return; }
  if (popup.querySelector('[data-welcome-error]')) { open(); return; }
  const stored = read();
  const preview = new URLSearchParams(location.search).get('welcome_preview') === '1';
  if (preview || popup.dataset.editor === 'true') { open(); return; }
  if (stored?.subscribed || (stored?.dismissed && Date.now() - stored.dismissed < week) || location.pathname.startsWith('/cart') || location.pathname.startsWith('/account')) return;
  setTimeout(open, Number(popup.dataset.delay || 10) * 1000);
})();
